// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure("add:paint-updated-sections", () => {
//                       this.cart.renderContents(response);
//                     });
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');

//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }





if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // ✅ Find form safely
        this.form = this.querySelector('form');
        if (!this.form) return; // Stop script if no form exists

        this.variantIdInput = this.form.querySelector('[name="id"]');
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButton.addEventListener(
          'click',
          this.onSubmitHandler.bind(this)
        );

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.form) return; // ✅ safety check

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const variantId = formData.get('id');

    const existingItem = cart.items.find(
      item => item.id == variantId
    );

    if (existingItem) {
      // ✅ already cart me hai → quantity badhao
      return fetch('/cart/change.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    id: existingItem.key,
    quantity: existingItem.quantity + 1,
    sections: this.cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname
  })
});
    } else {
      // ✅ new product → normal add
     formData.append(
  'sections',
  this.cart.getSectionsToRender().map((section) => section.id)
);
formData.append('sections_url', window.location.pathname);

return fetch('/cart/add.js', {
  method: 'POST',
  body: formData
});
    }
  })
  .then((response) => response.json())
          .then((response) => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
  source: 'product-form',
  productVariantId: formData.get('id'),
  cartData: response,
}).then(() => {
  this.cart.renderContents(response);
});
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });


                // ✅ 🔥 ADD THIS (IMPORTANT)
  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: 'product-form',
    productVariantId: formData.get('id'),
    cartData: response,
  });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                     // 🔥 IMPORTANT FIX

                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              // 🔥 IMPORTANT FIX

              });
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
